import React from 'react'

import classnames from 'classnames'
import { Button } from 'ethos-design-system'

import styles from '../Trustworthy.module.scss'

interface DualCTASectionProps {
  brandColorsClassName?: string
  arrowIcon?: boolean
  ctaClick: () => void
  secondCtaClick?: () => void
  arrowForward: React.ReactNode
  useOldFonts?: boolean
  useOldColors?: boolean
}

const DualCTASection: React.FC<DualCTASectionProps> = ({
  brandColorsClassName,
  arrowIcon,
  ctaClick,
  secondCtaClick,
  arrowForward,
  useOldFonts = false,
  useOldColors,
}) => {
  return (
    <div className={classnames(styles.dualCtaContainer)}>
      <div
        className={classnames(styles.cta, brandColorsClassName, {
          [styles.newFonts]: !useOldFonts,
        })}
      >
        <Button.Unstyled
          fullWidth
          arrowIcon={!!arrowIcon}
          onClick={() => ctaClick()}
        >
          <div className={styles.ctaLabel}>
            <div>
              <p
                className={classnames(
                  `font-[Theinhardt] text-lg font-medium leading-[110%%] tracking-[-0.18px] text-[#272727] max-[350px]:text-sm`,
                  {
                    [styles.newFontsTitle]: !useOldFonts,
                  }
                )}
              >
                Get life insurance prices
              </p>
              <p
                className={classnames(
                  `font-[Theinhardt] text-sm font-normal leading-[110%%] tracking-[-0.5px] text-[#272727] max-[350px]:text-xs`,
                  {
                    [styles.newFontsSubtitle]: !useOldFonts,
                  }
                )}
              >
                No medical exams or blood tests
              </p>
            </div>
            {arrowForward}
          </div>
        </Button.Unstyled>
      </div>
      <div
        className={classnames(styles.cta, brandColorsClassName, {
          [styles.newFonts]: !useOldFonts,
        })}
      >
        <Button.Unstyled
          fullWidth
          arrowIcon={!!arrowIcon}
          onClick={() => secondCtaClick?.()}
        >
          <div className={styles.ctaLabel}>
            <div>
              <p
                className={classnames(
                  `font-[Theinhardt] text-lg font-medium leading-[110%%] tracking-[-0.18px] text-[#272727] max-[350px]:text-sm`,
                  {
                    [styles.newFontsTitle]: !useOldFonts,
                  }
                )}
              >
                Create a will & trust
              </p>
              <p
                className={classnames(
                  `font-[Theinhardt] text-sm font-normal leading-[110%%] tracking-[-0.5px] text-[#272727] max-[350px]:text-xs`,
                  {
                    [styles.newFontsSubtitle]: !useOldFonts,
                  }
                )}
              >
                No expensive attorneys or appointments
              </p>
            </div>
            {arrowForward}
          </div>
        </Button.Unstyled>
      </div>
    </div>
  )
}

export default DualCTASection
